export default __webpack_public_path__ + "static/html-7e00f81dbbe3934ecb073ee4f10da06f.webp";